// Components/Auth/Register.js
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthAPI from "../../services/API/authServices"; // make sure filename is correct
import "./auth.css";
import { useNotification } from "../../context/NotificationContext";

export default function Register() {
  
  const { showNotification } = useNotification();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // eslint-disable-next-line
  const [isAdmin, setIsAdmin] = useState(true); // ✅ force admin register here
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await AuthAPI.register({ name, email, password, isAdmin });

      showNotification(
        ` ${res.message || "User registered successfully"}`,
        "success"
      );
      navigate("/login");
    } catch (err) {
      console.error("Register error", err);
      showNotification(
        err.response?.data?.message || " Registration failed",
        "error"
      );
    }
  };

  return (
    <div className="auth-container">
      <h2>Admin Register</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {/* If you want to allow Admin to create Managers too */}
        {/* <label>
            <input 
              type="checkbox" 
              checked={isAdmin} 
              onChange={(e) => setIsAdmin(e.target.checked)} 
            /> 
            Is Admin?
          </label> */}

        <button type="submit">Register</button>
      </form>
      <p>
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
}
